<template>
  <div>
    <div class="esp_page_query_new" :style="{height:height}">
      <div class="searchFrame">
        <slot></slot>
      </div>
      <div class="buttonFrame" :style="{width:btnWidth}">
        <el-button size="small" type="primary" v-if="searchMore" @click="showMoreBtn">
          <span>
            <i class="iconfont icon-gaojichaxun"></i>
          </span>
          <span style="font-size: 14px;">高级查询</span>
        </el-button>
        <slot name="btn"></slot>
      </div>
    </div>
    <div class="more-query">
      <div class="more-content" v-if="showMore">
        <div class="searchMore">
          <slot name="searchMore"></slot>
        </div>
        <div class="moreButton">
          <slot name="moreButton"></slot>
          <el-button icon="el-icon-search" type="primary" @click="queryAction">查询</el-button>
          <el-button icon="el-icon-scissors" @click="reSet"> 清空条件</el-button>
          <el-button icon="el-icon-close" @click="close">取消</el-button>
        </div>
      </div>
    </div>
    <esp-new-el-drawer :showLoading="false" ref="searchMoreDrawer" title="高级查询" okName="查询" cancelName="取消"
                       releaseName="清空条件" @doRelease="reSet" @doAction="queryAction">
      <div>
        <slot name="searchMore"></slot>
      </div>
    </esp-new-el-drawer>
  </div>
</template>

<script>
import EspNewElDrawer from "../dialog/EspNewElDrawer";

export default {
  name: "EspPageHeader",
  components: {EspNewElDrawer},
  data() {
    return {
      showMore: false
    }
  },
  props: {
    height: {  //header高度
      type: String,
      default: "auto"
    },
    btnWidth: {   //按钮区域宽度
      type: String,
      default: "300px"
    },
    searchMore: {   //高级查询
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeDisplay() {
      this.showMore = !this.showMore
    },
    showMoreBtn() {
      if (this.showMore) {
        this.showMore = false
      } else {
        // this.showMore = true
        this.$refs.searchMoreDrawer.opened()
      }
    },
    queryAction(callback) {
      this.$emit("queryAction")
      callback(true)
      this.showMore = false
    },
    reSet: function () {
      this.$emit("reSet")
    },
    close: function () {
      this.showMore = false
    },
  }
}
</script>

<style scoped>
.esp_page_query_new {
  /*width: 100%;*/
  background-color: #ffffff;
  padding: 20px 10px 10px 0px;
  /*-webkit-border-radius: 8px;*/
  /*-moz-border-radius: 8px;*/
  /*border-radius: 8px;*/
  display: flex;
  justify-content: space-between;
  /*border-bottom: 1px solid #eeeeee;*/
}

.searchFrame {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.buttonFrame {
  /*display: flex;*/
  padding-left: 10px;
  text-align: right;
  flex-shrink: 0;
  /*justify-content: flex-end;*/
  /*flex-direction: column;*/
  /*align-items: flex-end;*/
  /*justify-content: flex-end;*/
}

.more-query {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  z-index: 100;
}

.more-content {
  width: 100%;
  position: absolute;
  background-color: #ffffff;
  padding: 15px 0px;
  box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.4);
  border-top: 1px solid #eeeeee;
}

.moreButton {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0px 12px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageHeader.vue